import { LayoutModule } from '../../../layout/modules';
import { useState } from 'react';
import { FinalCausalityFilters } from './filters';
import { FinalCausalityList } from './list';
import { FINAL_CAUSALITY_NEW } from '../../../../routes/paths';
import { FinalCausalityFilter } from '../../../../shared/types/typifications/finalCausality';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';

export const FinalCausality = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [filters, setFilters] = useState<FinalCausalityFilter>();

    return (
        <>
            <LayoutModule
                title="Búsqueda de causalidad final"
                showTitle
                {...(!isOnlyViewProfile(type) && {
                    createPath: FINAL_CAUSALITY_NEW,
                })}
            >
                <FinalCausalityFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <FinalCausalityList filters={filters} />
        </>
    );
};
